import { Dropdown } from "react-bootstrap";
import { FC } from "react";
import { DropdownPropTypes } from "./types";
import { setShowLogoutPage } from "redux/slices";
import { useAppDispatch } from "redux/store";
import {passwordStorage} from "utils/password-storage";
import { selectLogin } from "redux/selectors";
import { useAppSelector } from "redux/store";

export const StrumentiDropdown: FC<DropdownPropTypes> = (props) => {
  const dispatch = useAppDispatch();
  const { guid } = useAppSelector(selectLogin);

  const handleLogout = () => {
    dispatch(setShowLogoutPage(true));
    passwordStorage.remove(guid);
  }
  
  return (
    <Dropdown.Menu className="dropdown-menu-end w-auto">
      <Dropdown.Item
        className="text-light fs-6 p-3 border-bottom"
        onClick={props.handleQrCode}
      >
        <i className="bi bi-phone mx-2"></i>
        Associa uno smartphone
      </Dropdown.Item>
      <Dropdown.Item
        className="text-light fs-6 p-3  border-bottom"
        onClick={props.handleFileSupportati}
      >
        <i className="bi bi-file-earmark-fill mx-2  border-bottom"></i>
        Formati file supportati
      </Dropdown.Item>

      <Dropdown.Item className="text-light fs-6 p-3" onClick={handleLogout}>
        <i className="bi bi-box-arrow-in-right mx-2"></i>Esci
      </Dropdown.Item>
    </Dropdown.Menu>
  );
};
